// 声明全局回调
import { isClient } from './utils';
var WEB_CALLBACK = [];
var onSuccessCache = Object.create(null);
var onFailCache = Object.create(null);
if (isClient) {
    window.__EMONEY_MOBILE_WEB_CALLBACK__ = WEB_CALLBACK;
    window.onSuccess = function (type, callbackParams) {
        console.info('onSuccess', type, callbackParams);
        if (onSuccessCache[callbackParams]) {
            onSuccessCache[callbackParams](type);
        }
    };
    window.onFail = function (type, callbackParams) {
        console.info('onFail', type, callbackParams);
        if (onFailCache[callbackParams]) {
            onFailCache[callbackParams](type);
        }
    };
}
/**
 * 回调函数代理
 */
export function callbackProxy(options) {
    var middlewareCallback = options.callback || function () { };
    var result = options;
    var callback = function (json) {
        if (typeof json === 'string') {
            try {
                json = JSON.parse(json);
            }
            catch (e) {
                console.error("\u56DE\u8C03\u53C2\u6570(" + json + ")\u9519\u8BEF\uFF0C\u65E0\u6CD5\u89E3\u6790\u4E3Ajson");
                json = {
                    msg: e
                };
            }
        }
        if (middlewareCallback) {
            middlewareCallback(json);
        }
    };
    if (options.onSuccess || options.onFail) {
        var timeStr = new Date().getTime() + '';
        result.callbackParams = timeStr;
        onSuccessCache[timeStr] = options.onSuccess || function () { };
        onFailCache[timeStr] = options.onFail || function () { };
    }
    else {
        result.callback = "__EMONEY_MOBILE_WEB_CALLBACK__[" + (WEB_CALLBACK.push(callback) - 1) + "]";
    }
    return result;
}
//# sourceMappingURL=callBackProxy.js.map